export const SELECTED_ENHANCEMENT_QUALITY_CHANGED = 'equipment/SELECTED_ENHANCEMENT_QUALITY_CHANGED';